"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardMapview = void 0;
var _mapboxGl = _interopRequireDefault(require("!mapbox-gl"));
var _pittaModules = require("@thingsw/pitta-modules");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //@ts-ignore
_mapboxGl["default"].accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
var DashboardMapview = function DashboardMapview(_ref) {
  var clusters = _ref.clusters;
  var mapContainer = (0, _react.useRef)(null);
  var map = (0, _react.useRef)(null);
  var clustersRef = (0, _react.useRef)([]);

  // 클러스터 그리기
  (0, _react.useEffect)(function () {
    if (map.current === null) return;

    // 지도에 그려지 있는 마커
    var drawnMarkers = clustersRef.current;
    var zones = clusters;
    var exists = _lodash["default"].chain(drawnMarkers).intersectionWith(zones, function (a, b) {
      return _lodash["default"].isEqual(a.zone, b);
    }).value();
    var deleted = _lodash["default"].chain(drawnMarkers).differenceWith(zones, function (a, b) {
      return _lodash["default"].isEqual(a.zone, b);
    }).value();
    var added = _lodash["default"].chain(zones).differenceWith(drawnMarkers, function (a, b) {
      return _lodash["default"].isEqual(a, b.zone);
    }).value();

    // console.log(
    //   "DashboardMapview",
    //   "clusters",
    //   clusters,
    //   "zones",
    //   zones,
    //   "exists",
    //   exists,
    //   "deleted",
    //   deleted,
    //   "added",
    //   added
    // );

    var addedMarkers = _lodash["default"].chain(added)
    //@ts-ignore
    .map(function (zone) {
      return (0, _pittaModules.makeClusterMarker)(map.current, zone);
    }).value();
    _lodash["default"].chain(deleted).map(function (marker) {
      return marker.remove();
    }).value();
    clustersRef.current = [].concat(_toConsumableArray(exists), _toConsumableArray(addedMarkers));
  }, [clusters]);
  (0, _react.useEffect)(function () {
    if (!mapContainer.current) return;
    // initialize map only once
    if (map.current === null) {
      var options = {
        container: mapContainer.current,
        style: _pittaModules.DEFAULT_MAP_STYLE,
        pitchWithRotate: false,
        dragRotate: false,
        touchPitch: false,
        center: {
          lng: 21.93430875468266,
          lat: 31.914329020568616
        },
        zoom: 1.7
      };
      map.current = new _mapboxGl["default"].Map(options);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: mapContainer,
    style: {
      width: "100%",
      height: "100%"
    }
  });
};
exports.DashboardMapview = DashboardMapview;